/**
 * Opens a Portal path in a new tab with no `window.opener`. The new tab is same-origin Portal, so
 * with an opener its script could navigate this tab. Modern browsers honour the `noopener` feature
 * and return `null`; IE 11 (still in `browserslist`) ignores it and returns the window, so the
 * link is cut by hand before that tab gets to run any script.
 */
export const openInNewTab = (path: string) => {
  const newTab = window.open(path, '_blank', 'noopener,noreferrer');
  if (newTab) newTab.opener = null;
};
